module.exports = __webpack_public_path__ + "r-v3/img/icon-schedule-group_green.dd1aaccd.svg";